export default __webpack_public_path__ + "static/media/img5.53a8fa43.webp";